export default __webpack_public_path__ + "static/media/1.51b43c0c.pdf";